import { clsx } from "clsx";

import {
  Combobox,
  ComboboxChip,
  ComboboxChips,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
  ComboboxValue,
} from "components/ui/combobox";
import { MultipleFilterTrigger } from "components/NewAdvancedSearch/filters/MultipleFilterTrigger";
import { useSelectFilterOptions } from "components/NewAdvancedSearch/filters/useSelectFilterOptions";
import { useStickyChipScroll } from "components/NewAdvancedSearch/filters/useStickyChipScroll";

const initialValue = {
  op: "in",
  value: [],
};

export function MultiSelectFilter({ descriptor, value, onChange }) {
  const { data, queryFn, key, props } = descriptor;
  const { isAsync, options, isFetching, onInputValueChange } =
    useSelectFilterOptions({ data, queryFn, queryKey: key, props });

  const current = value ?? initialValue;
  const selected = current.value ?? [];
  const { ref: chipsRef, onScroll: onChipsScroll } = useStickyChipScroll(
    selected.length
  );

  const handleChange = next => onChange({ ...current, value: next });

  const labelFor = o => o.name;

  return (
    <Combobox
      multiple
      items={options}
      value={selected}
      filter={isAsync ? null : undefined}
      onValueChange={handleChange}
      onInputValueChange={isAsync ? onInputValueChange : undefined}
      itemToStringLabel={o => o.name}
      isItemEqualToValue={(o, v) => o.id === v?.id}
    >
      <MultipleFilterTrigger labelFor={labelFor} keyFor={o => o.id} />
      <ComboboxContent>
        <ComboboxChips
          render={<div ref={chipsRef} onScroll={onChipsScroll} />}
          className={clsx(
            !selected.length && "tw:min-h-0 tw:p-0",
            "tw:bg-background tw:dark:bg-background tw:max-h-44 tw:overflow-y-auto"
          )}
        >
          <ComboboxValue>
            {selected =>
              selected.map(o => (
                <ComboboxChip
                  key={o.id}
                  className="tw:h-auto tw:max-w-full tw:min-w-0 tw:justify-start tw:text-left tw:whitespace-normal"
                >
                  <span className="tw:min-w-0 tw:wrap-anywhere">{o.name}</span>
                </ComboboxChip>
              ))
            }
          </ComboboxValue>
        </ComboboxChips>
        <ComboboxInput showTrigger={false} placeholder="Search" />
        <ComboboxEmpty>
          {isFetching ? "Loading…" : "No options found."}
        </ComboboxEmpty>
        <ComboboxList>
          {item => (
            <ComboboxItem key={item.id} value={item}>
              <span className="tw:wrap-anywhere">{item.name}</span>
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
